interface PageHeroProps {
  badge?: string;
  title: string;
  highlight?: string;
  subtitle?: string;
  image: string;
  children?: React.ReactNode;
}

export default function PageHero({ badge, title, highlight, subtitle, image, children }: PageHeroProps) {
  return (
    <section className="relative w-full min-h-[480px] md:min-h-[520px] overflow-hidden">
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50/45 md:to-background-50/40" />
      <div className="absolute inset-0 flex items-center">
        <div className="container mx-auto px-4 lg:px-8 w-full h-full flex items-center">
          <div className="ml-auto max-w-3xl text-right">
            {badge && (
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/10 mb-5">
                <span className="text-white text-xs font-medium uppercase tracking-widest">{badge}</span>
              </div>
            )}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-[1.1]">
              <span className="text-white [text-shadow:0_0_24px_rgba(0,0,0,0.92),0_0_8px_rgba(0,0,0,0.72)]">{title} </span>
              {highlight && <span className="gradient-text-primary drop-shadow-[0_0_16px_rgba(0,0,0,0.78)]">{highlight}</span>}
            </h1>
            {subtitle && (
              <p className="mt-4 text-lg text-white max-w-xl ml-auto [text-shadow:0_0_16px_rgba(0,0,0,0.84),0_0_5px_rgba(0,0,0,0.62)]">{subtitle}</p>
            )}
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}